import React from 'react';

export default function NavigationMobileMenu(props) {
  return (
    <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
      {props.children}
    </div>
  );
}
